
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"gst-svg-health-cross-icon",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.21 6.184V.2h5.58v5.984h6.376v5.632H12.79V17.8H7.21v-5.984H.834V6.184H7.21z","fill":"#cd1d32"}})])
          )
        }
      }
    